module.exports = __webpack_public_path__ + "img/nasil_belge.ac2f76b4.svg";